import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { default as ReactDropzone } from 'react-dropzone'
import ImageIcon from 'assets/svgs/image-icon.svg'
import { AppDropFileWrapper } from 'components/Common/AppDropzone/AppDropzone.style'
import { LoadingIndicator } from 'stream-chat-react'

interface IAppDropzoneProps {
  handleChange
  isMultiple: boolean
  uploadType: string
  fileExtensions: string[]
  uploadFileLoading: boolean
  isBorderVariantChanged: boolean
  isLoading?: boolean
}
export const AppDropzone: FC<IAppDropzoneProps> = ({
  handleChange,
  isMultiple,
  uploadFileLoading,
  isLoading = false,
}) => {
  const { t } = useTranslation()
  return (
    <div className="w-full flex flex-col items-center justify-center">
      <ReactDropzone
        onDrop={handleChange}
        multiple={isMultiple}
        disabled={uploadFileLoading || isLoading}
      >
        {({ getRootProps, getInputProps }) => (
          <section className="w-full relative">
            <AppDropFileWrapper {...getRootProps()}>
              <input {...getInputProps()} />
              <span className="mb-3 flex items-center justify-center">
                <img src={ImageIcon} alt="Upload" style={{ width: 36, height: 30 }} />
              </span>
              <span className="text-[#121212] text-base">
                {t('files.dropDocument')}{' '}
                <span className="text-[#705AF8] underline cursor-pointer">
                  {t('files.clickToBrowse')}
                </span>
              </span>
              <span className="text-[#A5A5A5] text-xs mt-1 block">
                .png, .jpg, .pdf, .doc, .xls
              </span>
              {isLoading && (
                <div className="flex items-center justify-center">
                  <LoadingIndicator size={20} />
                </div>
              )}
            </AppDropFileWrapper>
          </section>
        )}
      </ReactDropzone>
    </div>
  )
}
